import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const vobFormInfosSlice = createSlice({
  name: 'vobFormInfos',
  initialState: initialState,
  reducers: {
    clearVobFormInfos: () => {
      return initialState;
    },

    addVobFormInfo: (state, action) => {
      const { personId, vobFormInfo } = action.payload;
      const prevList = state[personId] || [];
      const newList = [...prevList, vobFormInfo];
      return { ...state, [personId]: newList };
    },

    addOrUpdateVobFormInfo: (state, action) => {
      const { personId, vobFormInfo } = action.payload;
      const prevList = state[personId] || [];
      const guidForThisItem = vobFormInfo.guid;
      const matchingItem = prevList.find((item) => item.guid === guidForThisItem);
      if (matchingItem) {
        // preserve the order
        const indexOfOldItem = prevList.indexOf(matchingItem);
        const before = prevList.slice(0, indexOfOldItem);
        const after = prevList.slice(indexOfOldItem + 1);
        const newList = [...before, vobFormInfo, ...after];
        return { ...state, [personId]: newList };
      } else {
        const newList = [...prevList, vobFormInfo];
        return { ...state, [personId]: newList };
      }
    },

    removeVobFormInfo: (state, action) => {
      const { personId, vobFormInfo } = action.payload;
      const prevList = state[personId] || [];
      const guidForThisItem = vobFormInfo.guid;
      const prunedList = prevList.filter((item) => item.guid !== guidForThisItem);
      return { ...state, [personId]: prunedList };
    },
  },
});

export const { clearVobFormInfos, addVobFormInfo, addOrUpdateVobFormInfo, removeVobFormInfo } =
  vobFormInfosSlice.actions;

export default vobFormInfosSlice.reducer;
